import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'

export const PreviewItemsWrapper = styled.div``
export const CurrentItemPreview = styled.div`
	position: relative;
	padding: ${rem(5, 15)};
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	background-color: ${({ theme }) => theme.color.secondary};
	border-radius: ${rem(4)};
	${(p) =>
		p.top30 &&
		css`
			margin-top: ${rem(30)};
		`}
	${(p) =>
		p.gray &&
		css`
			background-color: ${({ theme }) => theme.color.grayEight};
		`}
  	${(p) =>
		p.darkGray &&
		css`
			background-color: ${({ theme }) => theme.color.graySeventeen};
		`}
  	${(p) =>
		p.max472 &&
		css`
			max-width: ${rem(472)};
			margin: 0 auto;
		`}
  	${(p) =>
		p.cartView &&
		css`
			padding: 0;
			background: transparent;
			width: 100%;
		`}
	${(p) =>
		p.margin &&
		css`
			margin-bottom: ${rem(5)};
		`}
	${(p) =>
		p.isHandled === false &&
		css`
			box-shadow: inset 0 0 ${rem(1)} ${rem(2)}
				${({ theme }) => theme.color.graySeventeen};
			opacity: 0.5;
		`}
	${(p) =>
		p.isHandled &&
		css`
			box-shadow: inset 0 0 ${rem(1)} ${rem(2)}
				${({ theme }) => theme.color.blackOne};
			cursor: pointer;
		`}
	${(p) =>
		p.isActive &&
		css`
			box-shadow: inset 0 0 ${rem(1)} ${rem(2)}
				${({ theme }) => theme.color.primary};
			opacity: 1;
		`}
  	${(p) =>
		p.reclamationType &&
		css`
			margin: ${rem(7, 0)};
			@media (${device.mobileM}) {
				margin: ${rem(5, 0)};
				padding: ${rem(5, 7)};
			}
		`}
`
export const Preview = styled.div`
	height: ${rem(72)};
	flex: 0 0 ${rem(72)};
	max-width: ${rem(72)};
	margin: ${rem(0, 20)};

	img {
		display: block;
		object-fit: cover;
		max-width: 100%;
		height: 100%;
		border-radius: ${rem(2)};
	}

	${(p) =>
		p.reclamationType &&
		css`
			@media (${device.tablet}) {
				height: ${rem(56)};
				flex: 0 0 ${rem(56)};
				max-width: ${rem(56)};
				margin: ${rem(0, 13)};
			}
		`}
	${(p) =>
		p.reclamationType &&
		css`
			@media (${device.mobileM}) {
				display: none;
			}
		`}
`
export const Body = styled.div`
  flex: 1 0;
  font-weight: 600;
  color: ${({ theme }) => theme.color.blackOne};
  text-align: left;
  
  ${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
		`}
}
`
export const Price = styled.div`
	font-weight: 700;
	font-size: ${rem(18)};
	line-height: ${rem(25)};
	letter-spacing: ${rem(0.257143)};
	color: ${({ theme }) => theme.color.blackOne};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			font-size: ${rem(15)};
			letter-spacing: ${rem(0.06)};
			line-height: ${rem(20)};
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
		line-height: ${rem(20)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}
`
export const Name = styled.h2`
	font-size: ${rem(16)};
	line-height: ${rem(22)};
	margin-bottom: ${rem(3)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
		line-height: ${rem(20)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}
`
export const Status = styled.div`
	padding-top: ${rem(5)};
	font-size: ${rem(12)};
	line-height: ${rem(16)};
	font-style: italic;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`
export const DeleteIcon = styled.div`
	flex: 0 0 ${rem(35)};
	max-width: ${rem(35)};
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
	cursor: pointer;

	svg {
		fill: ${({ theme }) => theme.color.graySix};
	}

	&:hover svg {
		fill: ${({ theme }) => theme.color.blackOne};
	}

	${(p) =>
		p.reclamationType &&
		css`
			@media (${device.mobileM}) {
				display: none;
			}
		`}
`
export const OrderId = styled.div`
	font-size: ${rem(10)};
	position: absolute;
	right: ${rem(0)};
	top: ${rem(-5)};
`
export const FlowType = styled.div`
	font-size: ${rem(10)};
	position: absolute;
	right: ${rem(0)};
	top: ${rem(5)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}
`

export const ItemPreviewFlowSegment = styled.div``
export const ItemPreviewFlowSegmentTitle = styled.div`
	font-size: ${rem(12)};
	opacity: 0.5;

	${(p) =>
		p.isActive &&
		css`
			font-size: ${rem(14)};
			font-weight: 600;
			opacity: 1;
			color: ${({ theme }) => theme.color.primary};

			${(p) =>
				p.theme.name === merchantThemes.toteme &&
				css`
					font-weight: normal;
					font-size: ${rem(15)};
				`}
		`}
`
export const ItemPreviewFlowSegmentBody = styled.div``
